import { DateTime } from "luxon"
import { apiClientConfig } from "@/utils/api-utils"
import { AvailabilityApi, ProviderApi } from "@vitable/asclepius-api-client-ts"
import store from "@/store"

const state = () => ({
  subordinateProviders: []
  // <<Interface>> subordinateProviders:
  // [{
  //  providerId: String,
  //  providerFullName: String,
  //  appointmentsAwaitingApproval: Number,
  // }]
})

const getters = {
  totalSubordinateAppointmentsAwaitingApproval: (state) => {
    return state.subordinateProviders.reduce((count, subordinate) => {
      count += subordinate.appointmentsAwaitingApproval
      return count
    }, 0)
  }
}

const actions = {
  async getSubordinateProvidersAndAppointmentsAwaitingApproval({ commit }) {
    try {
      const providerApi = new ProviderApi(apiClientConfig())
      const availabilityApi = new AvailabilityApi(apiClientConfig())

      const subordinates = (
        await providerApi.listSubordinates({
          providerId: store.getters["me/provider"].id
        })
      ).data.results

      const appointmentsAwaitingApproval = subordinates.map((s) => {
        return availabilityApi.listAvailabilities({
          startDatetime: DateTime.now().toString(),
          endDatetime: DateTime.now().minus({ days: 30 }).toString(),
          onlyScheduledIn: true,
          onlyWaitingForApprovalIn: true,
          providerId: s.id
        })
      })
      const responses = await Promise.all(appointmentsAwaitingApproval)

      let subordinateProviders = []
      for (let i = 0; i < subordinates.length; i++) {
        subordinateProviders.push({
          providerId: subordinates[i].id,
          providerFullName: subordinates[i].full_name,
          appointmentsAwaitingApproval: responses[i].data.results.length
        })
      }

      commit("setSubordinateProviders", { subordinateProviders })
    } catch (e) {
      console.error(`Failed to getSubordinateProvidersAndAppointmentsAwaitingApproval - ${e}`)
      throw new Error(e)
    }
  }
}

const mutations = {
  setSubordinateProviders(state, { subordinateProviders }) {
    state.subordinateProviders = subordinateProviders
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
